<template>
  <div class="chart-container" style='position: relative !important; width: 100% !important;'>
    <canvas :id="idcanvas" style="width: 100% !important; height: 100%"></canvas>
  </div>
</template>
<script>
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  props: {
    datagraph: {
      type: Object
    },
    cambio: Number
  },
  data() {
    return {
      idcanvas: "",
      chart: null,
      colorbase: [
        "#293462",
        "#f76262",
        "#216583",
        "#aee7e8",
        "#28c3d4",
        "#fbc99d",
        "#ed1250",
        "#10ddc2",
        "#042f4b",
        "#15b7b9",
        "#f57170",
        "#248ea9"
      ]
    };
  },
  created() {
    this.idcanvas = Math.random()
        .toString(36)
        .substr(2, 9);
  },
  mounted() {
    if (this.datagraph.data) {
      this.render(this);
    }
  },
  methods: {
    render(_this) {
      // const _this = this;
      Chart.defaults.global.defaultFontFamily = "'Montserrat', sans-serif"; // con esto configuramos el tipo de letra
      Chart.defaults.global.tooltips.backgroundColor = "rgba(45, 64, 89, 0.9)"; // con esto se configura el fondo del tooltip
      Chart.plugins.unregister(ChartDataLabels);

      const ctx = document.getElementById(_this.idcanvas);
      ctx.getContext("2d");


      if (_this.datagraph.type === 'horizontalBar' || _this.datagraph.type === 'pie'){
        _this.datagraph.plugins = [ChartDataLabels]
      }

      if (_this.chart) {
        // si la grafica ya existia la destruimos
        _this.chart.destroy();
      }

      _this.chart = new Chart(ctx, _this.datagraph);
    },
    updated(_this){
      _this.chart.data = _this.datagraph.data;
      _this.chart.update()
    }
  },
  watch: {
    cambio(newv, oldv) {
      if (this.datagraph.data) {
        this.updated(this);
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/GraphFrs.vue